import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Utils
import { translation } from '../../../../utils/helpers'

// Elements
import Textarea from '../../../elements/textarea'
import Check from '../../../elements/check'

class Estimation extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }

  render () {
    let canEstimate = this.props.evaluationAllowed

    return (
      <div>
        <Check labelText={translation('13363')} helpText={translation('1934')} disabled={!canEstimate} id='estimation' name='Estimation' value='1' onChange={this.props.onInputChange} checked={this.props.showComment} />
        {this.props.showComment && (
          <Textarea labelText={translation('13364')} name='Estimation_comment' onChange={this.props.onInputChange} value={this.props.comment} />
        )}
      </div>
    )
  }
}

Estimation.propTypes = {
  evaluationAllowed: PropTypes.bool.isRequired,
  showComment: PropTypes.bool.isRequired,
  comment: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired
}

export default Estimation



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/Estimation/index.js